import {Directive, HostBinding, Input, OnInit} from "@angular/core";
import {FormControl} from "@angular/forms";

@Directive()
export abstract class FUIAbstractValidation implements OnInit {
    @Input() public control: FormControl;
    protected _focussed: boolean;
    @HostBinding("class.valid") public valid: boolean;

    constructor(){
    }

    ngOnInit(): void {

    }

    /**
     *
     * @returns {boolean}
     */
    get focussed(): boolean {
        return this._focussed;
    }

    /**
     *
     * @param {boolean} focussed
     */
    @Input()
    set focussed(focussed: boolean) {
        if (this.focussed !== focussed) {
            this._focussed = focussed;
        }
    }

    /**
     *
     */
    public validity(): void {

    }
}
